import ScreenDevice from './ScreenDevice'
export default ScreenDevice
